import { URLS } from '../../../constants';
import apiClient from '../../client';
const getEventsByProvidersAPI = {
    getEventsByProviders: ({
        userIds,
        appointmentStartDate,
        appointmentEndDate,
    }: {
        userIds: any;
        appointmentStartDate: any;
        appointmentEndDate: any;
    }) =>
        apiClient.post(URLS.getEventsByProviders, {
            data: {
                userIds,
                appointmentStartDate,
                appointmentEndDate,
            },
        }),
};
export default getEventsByProvidersAPI;
